import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";
import { LIGHT_GREY } from "styles/oneOffColor";

import StyledButton from "components/Styled/Button";
import { useTracking } from "utils/useTracking";

const Welcome = () => {
  const navigate = useNavigate();
  const { trackVaStep } = useTracking();

  return (
    <>
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          textAlign: "center",
          mt: 0,
          fontWeight: 400,
          mb: 4,
        }}
      >
        <Box component="span" sx={{ fontSize: 20, color: "black" }}>
          Welcome to
        </Box>{" "}
        <br />{" "}
        <Box component="span" sx={{ color: "green.main", fontSize: 50 }}>
          AI Virtual Assistant
        </Box>{" "}
        🎉
      </Typography>

      <Grid container gap={3}>
        <Grid
          item
          xs={12}
          md={5.7}
          sx={{
            backgroundColor: "#004537",
            px: 6,
            py: 3,
            borderRadius: "20px",
          }}
        >
          <Typography
            sx={{
              color: "yellow.main",
              fontSize: 25,
              mb: 2,
            }}
          >
            ✨ We Pitch
          </Typography>

          <Typography
            sx={{ color: LIGHT_GREY, fontFamily: "Open Sans", fontSize: 16 }}
          >
            Bento's AI sends 300+ emails on your behalf each month, without you
            lifting a finger.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md
          sx={{
            backgroundColor: LIGHT_GREY,
            px: 6,
            py: 3,
            borderRadius: "20px",
          }}
        >
          <Typography
            sx={{
              color: "black",
              fontSize: 25,
              mb: 2,
            }}
          >
            👉 You Respond
          </Typography>

          <Typography
            sx={{ color: "black", fontFamily: "Open Sans", fontSize: 16 }}
          >
            You are responsible for responding to and negotiating with brands
            when you get a response.
          </Typography>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" sx={{ mt: 6 }}>
        <StyledButton
          disableElevation
          styles={{ px: 3, fontSize: 16 }}
          onClick={() => {
            navigate(`/${routes.aboutSelfServeOnboarding}`);
            trackVaStep(routes.aboutSelfServeOnboarding);
          }}
        >
          Let's Get Started{" "}
          <Box
            sx={{ ml: 1 }}
            component="i"
            className="fa-regular fa-circle-arrow-right"
          />
        </StyledButton>
      </Grid>
    </>
  );
};

export default Welcome;
